<template>

  <div class="prev-next-page">

    <div  v-if="idEstrattoConto != 'null'">
      <div>
        <Carousel :value="adjacentSameType" :page="pageIndex" :numVisible="numVisible" :numScroll="3">
          <template #header>
             <h4 class="pl-7">Movimenti adiacenti a {{currentEstrattoConto.cod_type_mode_name}}</h4>
          </template>
          <template #item="slotProps">
            <div class="flex align-items-center justify-content-center flex-column">
              <div class="card-carousel m-2 p-4 surface-overlay">
                <div class="mb-1 flex justify-content-center">
                  <div v-if="slotProps.data.current">
                    <div class="sa">
                      <div class="sa-success">
                      <div class="sa-success-tip"></div>
                      <div class="sa-success-long"></div>
                      <div class="sa-success-placeholder"></div>
                      <div class="sa-success-fix"></div>
                      </div>
                      </div>
                  </div>
                  <img v-else  src="@/assets/img/money.png" width="100" />
                </div>
                <div class="text-center mb-3 text-blue-300">
                  <small>{{formatDate(slotProps.data.data_contabile)}}</small>
                </div>
                <div class="">
                  <h5 class="mb1">{{slotProps.data.cod_type_mode_name}}</h5>
                  <div style="min-height:60px">
                    <div class="mt-0 mb-3 text-500">{{slotProps.data.descrizione.slice(0, 80)}}...</div>
                  </div>
                  <h4 class="mb1 text-blue-500">{{slotProps.data.value}} €</h4>
                  <div class="mt-5" v-if="!slotProps.data.current">
                    <router-link :to="{ path: `/estratti-conto/detail/not-regularized/${slotProps.data.id}`}">
                      <Button label="VEDI" class="uppercase p-button w-full" />
                    </router-link>
                  </div>
                  <div v-else-if="Number(slotProps.data.used) === 1">
                    <router-link :to="{ path: `/estratti-conto/detail/regularized/${slotProps.data.id}`}">
                      <Button label="regolarizzato" class="uppercase p-button-success w-full" />
                    </router-link>
                  </div>
                  <div v-else-if="Number(slotProps.data.is_movimento_ignoto) === 1">
                    <router-link :to="{ path: `/estratti-conto/detail/not-regularized/${slotProps.data.id}`}">
                      <Button label="movimento ignoto" class="uppercase p-button-success w-full" />
                    </router-link>
                  </div>
                  <div v-else>
                    <router-link :to="{ path: `/estratti-conto/detail/not-regularized/${slotProps.data.id}`}">
                      <Button label="VEDI" class="uppercase p-button w-full" />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Carousel>
      </div>

    
      <div>
        <Carousel :value="adjacent" :numVisible="2" :numScroll="2">
          <template #header>
             <h4 class="pl-7">Movimenti adiacenti</h4>
          </template>
          <template #item="slotProps">
            <div class="flex align-items-center justify-content-center flex-column">
              <div class="card-carousel m-2 p-4 surface-overlay">
                <div class="mb-1 flex justify-content-center">
                  <img alt="Logo" src="@/assets/img/money.png" width="100" />
                </div>
                <div class="text-center mb-3 text-blue-300">
                  <small>{{slotProps.data.data_contabile}}</small>
                </div>
                <div class="">
                  <h5 class="mb-1">{{slotProps.data.cod_type_mode_name}}</h5>
                  <div style="min-height:40px">
                    <div class="text-500 mt-0 mb-3">{{slotProps.data.descrizione.slice(0, 80)}}...</div>
                  </div>
                  <h4 class="text-blue-500 mb-1">{{slotProps.data.value}} €</h4>
                  <div class="mt-5">
                     <router-link :to="{ path: `/estratti-conto/detail/not-regularized/${slotProps.data.id}`}">
                      <Button label="VEDI" class="uppercase p-button w-full" />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Carousel>
      </div>
    </div>
     
    <!-- for note credito acquisto/vendita -->
    <div v-else>  
        
        <div class="flex align-items-center justify-content-center flex-column">
          <div class="card-carousel m-2 p-4 surface-overlay">
            <div class="mb-1 flex justify-content-center">
              <div>
                <div class="sa">
                  <div class="sa-success">
                  <div class="sa-success-tip"></div>
                  <div class="sa-success-long"></div>
                  <div class="sa-success-placeholder"></div>
                  <div class="sa-success-fix"></div>
                  </div>
                  </div>
              </div>
            </div>
            <div class="text-center mb-3 text-blue-300">
            </div>
            <div class="">
              <h5 class="mb1">NOTA CREDITO</h5>
              <div style="min-height:60px">
                <div class="mt-0 mb-3 text-500">Regolarizzata oggi: {{moment().format('DD-MM-YYYY')}}</div>
              </div>
              <div>
                  <Button label="regolarizzata" class="uppercase p-button-success w-full" disabled />
              </div>
            </div>
          </div>
        </div>

    </div>
</div>

</template> 

<script>
import moment from 'moment'
import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import {useRoute} from 'vue-router';


export default {

    components: {

    },
    setup() {
      const route = useRoute()
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const idEstrattoConto = route.params.id
      const currentEstrattoConto = ref({})
      const adjacent = ref([])
      const adjacentSameType = ref([])
      const pageIndex = ref(0)
      const numVisible = 3
      


      onMounted(() => {
        if (idEstrattoConto != 'null') {
          service.getPrevNextDetail(idEstrattoConto).then((res) => {
              if (res.items) {
                currentEstrattoConto.value = res.items.current
                currentEstrattoConto.value['current'] = true
                if (res.items.previous.length > 0) {
                  adjacent.value.push(res.items.previous[0])
                }
                if (res.items.next.length > 0) {
                  adjacent.value.push(res.items.next[0])
                }
                
                res.items.nextSameType.unshift({...currentEstrattoConto.value})
                let temp = res.items.previousSameType.concat(res.items.nextSameType);
                let tempObj = temp.map((item) => {
                  return { ...item, current: item.id == idEstrattoConto ? true : false };
                });
 
                let indexCurrent = tempObj.findIndex(el => el.id == idEstrattoConto);
                pageIndex.value = parseInt(indexCurrent / numVisible)
                adjacentSameType.value = tempObj
                
              }
          })
        }
      })

      return {
        moment,
        formatDate,
        idEstrattoConto,
        currentEstrattoConto,
        adjacent,
        adjacentSameType,
        pageIndex,
        numVisible
      }

    }
}
</script>

<style scoped>
.prev-next-page .carousel-item-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.prev-next-page .card-carousel {
  border-radius: 12px;
  width: 96%;
  height: 100%;
  min-height: 282px;
}
.sa {
  width: 110px;
  height: 110px;
  padding: 14px;
  background-color: #fff;
}
.sa-success {
  border-radius: 50%;
  border: 4px solid #a5dc86;
  box-sizing: content-box;
  height: 80px;
  padding: 0;
  position: relative;
  background-color: #fff;
  width: 80px;
}
.sa-success:after, .sa-success:before {
  background: #fff;
  content: "";
  height: 120px;
  position: absolute;
  transform: rotate(45deg);
  width: 60px;
}
.sa-success:before {
  border-radius: 40px 0 0 40px;
  width: 26px;
  height: 80px;
  top: -17px;
  left: 5px;
  transform-origin: 60px 60px;
  transform: rotate(-45deg);
}
.sa-success:after {
  border-radius: 0 120px 120px 0;
  left: 30px;
  top: -11px;
  transform-origin: 0 60px;
  transform: rotate(-45deg);
  animation: rotatePlaceholder 4.25s ease-in;
}
.sa-success-placeholder {
  border-radius: 50%;
  border: 4px solid rgba(165, 220, 134, 0.25);
  box-sizing: content-box;
  height: 80px;
  left: -4px;
  position: absolute;
  top: -4px;
  width: 80px;
  z-index: 2;
}
.sa-success-fix {
  background-color: #fff;
  height: 90px;
  left: 28px;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 5px;
  z-index: 1;
}
.sa-success-tip, .sa-success-long {
  background-color: #a5dc86;
  border-radius: 2px;
  height: 5px;
  position: absolute;
  z-index: 2;
}
.sa-success-tip {
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
  width: 25px;
  animation: animateSuccessTip 0.75s;
}
.sa-success-long {
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
  width: 47px;
  animation: animateSuccessLong 0.75s;
}

@keyframes animateSuccessTip {
  0%, 54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0%, 65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0%, 5% {
    transform: rotate(-45deg);
  }
  100%, 12% {
    transform: rotate(-405deg);
  }
}
</style>
